import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Profil() {
  const [anunturiMele, setAnunturiMele] = useState([]);
  const [favorite, setFavorite] = useState([]);
  const [mesaje, setMesaje] = useState([]);
  const utilizator = JSON.parse(localStorage.getItem('utilizator'));

  useEffect(() => {
    fetchAnunturi();
    incarcaFavorite();
    incarcaMesaje();
  }, []);

  const fetchAnunturi = async () => {
    const token = localStorage.getItem('token');
    const raspuns = await fetch('https://tranzitio.onrender.com/api/anunturi/mele/toate', {
      headers: { 'x-auth-token': token }
    });
    const date = await raspuns.json();
    setAnunturiMele(date);
  };

  const incarcaFavorite = async () => {
    const token = localStorage.getItem('token');
    const res = await fetch('https://tranzitio.onrender.com/api/favorite/mele', {
      headers: { 'x-auth-token': token }
    });
    const date = await res.json();
    setFavorite(date);
  };

  const incarcaMesaje = async () => {
  try {
    const token = localStorage.getItem('token');
    const res = await fetch('https://tranzitio.onrender.com/api/mesaje/primite', {
      headers: { 'x-auth-token': token }
    });
    
    const date = await res.json();
    
    if (Array.isArray(date)) {
      setMesaje(date);
    } else {
      console.error('Eroare de la server:', date);
      setMesaje([]); 
    }
  } catch (err) {
    console.error('Eroare la citirea mesajelor:', err);
    setMesaje([]);
  }
};

  const stergeAnunt = async (id) => {
    if (window.confirm('Esti sigur ca vrei sa stergi acest anunt?')) {
      const token = localStorage.getItem('token');
      const raspuns = await fetch(`https://tranzitio.onrender.com/api/anunturi/${id}`, {
        method: 'DELETE',
        headers: { 'x-auth-token': token }
      });

      if (raspuns.ok) {
        setAnunturiMele(anunturiMele.filter(a => a._id !== id));
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-md p-4 flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold text-blue-600">TRANZITIO</Link>
        <Link to="/" className="text-gray-600 hover:text-blue-600 font-medium">Inapoi la site</Link>
      </nav>

      <main className="max-w-6xl mx-auto p-6">
        <div className="bg-white p-8 rounded-2xl shadow-sm mb-8 border border-gray-100">
          <h2 className="text-2xl font-bold text-gray-800">Profilul meu</h2>
          <p className="text-gray-500 font-medium mt-2">Nume: {utilizator?.nume}</p>
          <p className="text-gray-500 font-medium">Email: {utilizator?.email}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
            <h3 className="text-xl font-bold mb-6 text-gray-800 flex items-center gap-2">
              Inbox Mesaje
              <span className="bg-blue-100 text-blue-600 px-2 py-1 rounded-full text-xs">{mesaje.length}</span>
            </h3>
            <div className="space-y-4">
              {Array.isArray(mesaje) && mesaje.map(mesaj => (
                  <div key={mesaj._id} className="bg-gray-50 p-5 rounded-xl border border-gray-100 hover:shadow-md transition">
                  <p className="text-sm text-gray-600">
                    Mesaj de la: <span className="font-bold text-gray-900">{mesaj.expeditor?.nume}</span>
                  </p>
                  <p className="text-sm text-gray-600 mb-3">
                    Referitor la: <span className="font-medium text-blue-600">{mesaj.anunt?.titlu}</span>
                  </p>
                  <div className="bg-white p-4 rounded-lg text-gray-800 shadow-sm border border-gray-50">
                    {mesaj.text}
                  </div>
                  <p className="text-xs text-gray-400 mt-3 font-medium">
                    {new Date(mesaj.dataTrimiterii).toLocaleString()}
                  </p>
                </div>
              ))}
              {mesaje.length === 0 && (
                <div className="text-center py-10 bg-gray-50 rounded-xl border border-dashed border-gray-200">
                  <p className="text-gray-500">Casuta de mesaje este goala.</p>
                </div>
              )}
            </div>
          </div>

          <div className="space-y-8">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
              <h3 className="text-xl font-bold mb-6 text-gray-800">Anunturile mele publicate</h3>
              <div className="space-y-4">
                {anunturiMele.map(anunt => (
                  <div key={anunt._id} className="bg-gray-50 p-4 rounded-xl flex items-center justify-between border border-gray-100 group hover:shadow-md transition">
                    <div className="flex items-center gap-4">
                      <div className="w-16 h-16 bg-white rounded-lg overflow-hidden border">
                        {anunt.imagine && <img src={anunt.imagine} className="w-full h-full object-cover" alt="" />}
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-800 line-clamp-1">{anunt.titlu}</h4>
                        <p className="text-blue-600 font-bold text-sm">{anunt.pret} RON</p>
                      </div>
                    </div>
                    <button 
                      onClick={() => stergeAnunt(anunt._id)}
                      className="bg-white text-red-500 px-4 py-2 rounded-lg hover:bg-red-50 hover:text-red-600 transition font-bold text-sm shadow-sm border border-red-100"
                    >
                      Sterge
                    </button>
                  </div>
                ))}
                {anunturiMele.length === 0 && <p className="text-gray-500 italic">Nu ai publicat niciun anunt inca.</p>}
              </div>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
              <h3 className="text-xl font-bold mb-6 text-gray-800 flex items-center gap-2">
                Favorite salvate
                <span className="text-red-500">❤</span>
              </h3>
              <div className="space-y-4">
                {favorite.map(f => (
                  <div key={f._id} className="bg-gray-50 p-4 rounded-xl border border-gray-100 hover:shadow-md transition flex justify-between items-center">
                    <Link to={`/anunt/${f.anunt?._id}`} className="flex items-center gap-4 flex-grow">
                      {f.anunt?.imagine && <img src={f.anunt?.imagine} className="w-12 h-12 rounded-lg object-cover border" alt="" />}
                      <span className="font-bold text-gray-700 line-clamp-1 hover:text-blue-600 transition">{f.anunt?.titlu}</span>
                    </Link>
                    <span className="text-blue-600 font-black whitespace-nowrap ml-4 bg-blue-50 px-3 py-1 rounded-lg">{f.anunt?.pret} RON</span>
                  </div>
                ))}
                {favorite.length === 0 && <p className="text-gray-500 italic">Nu ai salvat niciun anunt la favorite.</p>}
              </div>
            </div>
          </div>

        </div>
      </main>
    </div>
  );
}

export default Profil;